module.exports = __webpack_public_path__ + "static/media/pause_overlay.5cf85520.svg";